const initialStateRelationship = {
  relationship: [],
  relationship_update: false,
};

export default initialStateRelationship;